import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Trophy, ArrowLeft, Film, ImageIcon } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MurLegendesPage() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios.get(`${API}/distinctions`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#71717A] hover:text-[#C5A059] transition-colors">
          <ArrowLeft size={14} /> Retour à l'accueil
        </Link>
        <div className="mt-10 mb-12">
          <p className="text-[10px] uppercase tracking-[0.35em] text-[#C5A059]">Dream2Reality Football Agency</p>
          <h1 className="font-display text-5xl md:text-7xl uppercase font-bold mt-3" data-testid="mur-title">
            Mur des <span className="text-[#C5A059]">Légendes</span>
          </h1>
          <p className="text-[#A1A1AA] mt-4 max-w-2xl">
            Les reconnaissances décernées lors de nos détections : meilleur joueur, meilleure joueuse, hommes du match et tous les trophées remis à Kinshasa.
          </p>
        </div>

        {!items ? (
          <p className="text-center text-[#71717A] py-16">Chargement…</p>
        ) : items.length === 0 ? (
          <div className="border border-[#27272A] p-16 text-center" data-testid="mur-empty">
            <Trophy size={36} className="mx-auto text-[#C5A059]/50" />
            <p className="text-[#71717A] mt-4">Le mur s'enrichira des distinctions remises lors de la détection de Novembre 2026.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="mur-grid">
            {items.map((d) => (
              <article key={d.id} className="group border border-[#27272A] bg-[#121214] overflow-hidden hover:border-[#C5A059]/50 transition-colors" data-testid={`mur-card-${d.id.slice(0, 8)}`}>
                {d.media_url && d.media_type !== "video" && (
                  <div className="aspect-[4/3] overflow-hidden bg-black">
                    <img src={d.media_url} alt={d.titre} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" />
                  </div>
                )}
                {d.media_url && d.media_type === "video" && (
                  <video src={d.media_url} controls className="w-full aspect-[4/3] object-cover bg-black" />
                )}
                <div className="p-6">
                  <p className="text-[10px] uppercase tracking-widest text-[#C5A059]">
                    {d.programme || "Détection D2R"}{d.date_evenement ? ` · ${d.date_evenement}` : ""}
                  </p>
                  <h2 className="font-display text-xl uppercase font-semibold mt-2">{d.titre}</h2>
                  <p className="text-white mt-2 flex items-center gap-2 text-sm">
                    <Trophy size={14} className="text-[#C5A059]" /> {d.personne}
                  </p>
                  {d.description && <p className="text-[#A1A1AA] text-sm mt-3 leading-relaxed">{d.description}</p>}
                  {!d.media_url && (
                    <p className="mt-4 text-[10px] uppercase tracking-widest text-[#3f3f46] flex items-center gap-2">
                      <ImageIcon size={12} /> <Film size={12} /> Photo / vidéo à venir
                    </p>
                  )}
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
